document.addEventListener('click', function (event) {
  var locBtn = event.target.closest('[data-loc]');
  if (locBtn) {
    locBtn.parentElement.querySelectorAll('[data-loc]').forEach(function (btn) {
      btn.classList.toggle('is-on', btn === locBtn);
    });
    var city = document.querySelector('.tbx-loc-city span');
    if (city) {
      var map = { QA: 'Doha, Qatar', IN: 'India', OTHER: 'Other Country' };
      city.textContent = map[locBtn.getAttribute('data-loc')] || city.textContent;
    }
  }

  var giftOpt = event.target.closest('.tbx-gift-opts button');
  if (giftOpt) {
    giftOpt.parentElement.querySelectorAll('button').forEach(function (btn) {
      btn.classList.toggle('is-on', btn === giftOpt);
    });
  }

  if (event.target.id === 'TbxRemoveSelected') {
    var cart = document.querySelector('cart-items');
    if (!cart) return;
    document.querySelectorAll('.tbx-cart-pick:checked').forEach(function (box) {
      cart.updateQuantity(box.getAttribute('data-index'), 0);
    });
  }
});

document.addEventListener('change', function (event) {
  if (event.target.matches('[data-tbx-gift]')) {
    var panel = event.target.closest('.tbx-cart-item__info').querySelector('.tbx-gift-panel');
    if (panel) panel.hidden = !event.target.checked;
  }

  if (event.target.id === 'TbxSelectAll') {
    document.querySelectorAll('.tbx-cart-pick').forEach(function (box) {
      box.checked = event.target.checked;
    });
  }
});
